export const isValidPersonName = (value) => {
  const name = String(value || '').trim().replace(/\s+/g, ' ');
  return name.length >= 2 && name.length <= 100 && /^[\p{L}\p{M} ]+$/u.test(name);
};

export const isStrongPassword = (value) => {
  const password = String(value || '');
  return password.length >= 8
    && /[A-Z]/.test(password)
    && /[a-z]/.test(password)
    && /\d/.test(password)
    && /[^A-Za-z0-9\s]/.test(password)
    && !/\s/.test(password);
};
